import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { brand } from '../config/brand';
import { useLocale } from '../lib/use-locale';
import { legalLinks, pagePath } from '../config/page-routes';

export function SiteFooter() {
  const { t } = useTranslation();
  const locale = useLocale();
  const year = new Date().getFullYear();

  const contactHref = `${pagePath('home', locale)}#contact`;

  return (
    <footer className="site-footer">
      <div className="container">
        {/* Top row: copyright · contact · socials */}
        <div className="site-footer__top">
          <p className="site-footer__copy">
            © {year} {brand.name}
            {brand.practitioner.name ? ` · ${brand.practitioner.name}` : ''}
            {brand.practitioner.licenseNumber ? ` · ${t('footer.licenseShort')}` : ''}
          </p>

          <p className="site-footer__contact">
            <a href={`tel:${brand.contact.landline}`}>{brand.contact.landlineDisplay}</a>
            {' · '}
            <a href={brand.contact.whatsapp} target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
            {' · '}
            <a href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
          </p>

          <div className="site-footer__social" aria-label="Redes sociales">
            <a
              href={brand.contact.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a
              href={brand.contact.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <a
              href={brand.contact.youtube}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.54C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Bottom row: page links centered */}
        <nav className="site-footer__links" aria-label="Footer navigation">
          <Link to={pagePath('faq', locale)}>{t('footer.faq')}</Link>
          <a href={contactHref}>{t('footer.contact')}</a>
          {legalLinks.map((page) => (
            <Link key={page} to={pagePath(page, locale)}>
              {t(`footer.${page}`)}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
